export const types = {
	request: '[Auth] Request login',
	login: '[Auth] Login Success',
	logout: '[Auth] Logout',
	error: '[Auth] Login Error',
}